import { render, staticRenderFns } from "./relationshipTree.vue?vue&type=template&id=c5611298&scoped=true"
import script from "./relationshipTree.vue?vue&type=script&lang=js"
export * from "./relationshipTree.vue?vue&type=script&lang=js"
import style0 from "./relationshipTree.vue?vue&type=style&index=0&id=c5611298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5611298",
  null
  
)

export default component.exports